export default "__VITE_ASSET__3qJfvy49__"